var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoodOnIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9163 15.6582L7.9418 6.6837C7.82543 6.56734 7.67998 6.50916 7.53452 6.50916H7.4618C7.21452 6.50916 7.01089 6.65461 6.92361 6.87279C6.54543 7.84734 6.37089 8.85097 6.44361 9.76734C6.53089 10.8146 6.92361 11.7164 7.5927 12.3855L14.7345 19.5273L15.68 18.5819L22.2836 25.9564C22.9382 26.611 24.0727 26.6546 24.7709 25.9564C25.4545 25.2728 25.4545 24.1528 24.7709 23.4692L16.9163 15.6582Z",
    fill: "#C0C8D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77445 23.4836C5.09081 24.1673 5.09081 25.2873 5.77445 25.9709C6.42899 26.6255 7.54899 26.6837 8.26172 25.9709L13.8472 20.3855L11.3599 17.8982L5.77445 23.4836Z",
    fill: "#C0C8D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5308 9.17099C26.2544 8.89463 25.7889 8.89463 25.5126 9.17099L22.1089 12.5746L21.0908 11.5564L24.4944 8.15281C24.7708 7.87645 24.7708 7.41099 24.4944 7.13463C24.218 6.85826 23.7526 6.85826 23.4762 7.13463L20.0726 10.5383L19.0544 9.52008L22.458 6.11645C22.7344 5.84008 22.7344 5.37463 22.458 5.09826C22.1817 4.8219 21.7162 4.8219 21.4399 5.09826L16.8435 9.69463C16.2326 10.3055 15.8253 11.1201 15.7962 11.9928C15.7817 12.2255 15.738 12.4583 15.6508 12.6764L18.9671 15.9928C19.1853 15.9055 19.418 15.8474 19.6508 15.8474C20.5235 15.8183 21.338 15.411 21.9489 14.8001L26.5453 10.2037C26.8217 9.91281 26.8217 9.44736 26.5308 9.17099Z",
    fill: "#C0C8D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodOnIcon);
export default __webpack_public_path__ + "static/media/food_on_icon.c987533d29fcca28a1186011677fefa2.svg";
export { ForwardRef as ReactComponent };